import { Link } from "react-router-dom";
import "./styles/PrivacyPage.css";

export function PrivacyPage() {
  return (
    <article className="section privacy container">
      <div className="privacy__body">
        <p className="eyebrow">Privacy</p>
        <h1 className="section__title">Privacy notice</h1>
        <p className="section__lead">
          This notice explains what we do with the details you give us on this website. It doesn't cover the SENfully app itself, which has its own.
        </p>

        <h2>What we collect</h2>
        <p>
          When you request access, we collect your name, your email address and, if you choose to write it, a few words about you.
          When you send us a message, we collect your name, your email address and your message.
        </p>

        <h2>Why we collect it</h2>
        <p>
          We use these details only to reply to you and to decide whether to invite you to SENfully. We don't use them for marketing
          and we don't sell or share them.
        </p>

        <h2>Who can see it</h2>
        <p>Only the small SENfully team who review requests and answer messages.</p>

        <h2>How long we keep it</h2>
        <p>
          If we can't offer you access, we delete your request 30 days later. Requests we've accepted and messages we've replied to are kept
          for as long as we need them for that purpose, and we delete them when you ask.
        </p>

        <h2>Cookies and tracking</h2>
        <p>This website doesn't use cookies and doesn't track you with analytics.</p>

        <h2>Your rights</h2>
        <p>
          You can ask us at any time to show you what we hold about you, correct it, or delete it. Use the <Link to="/contact">contact form</Link> and
          tell us which you'd like.
        </p>
      </div>
    </article>
  );
}
